import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { RefusalPaymentDto } from 'src/app/domain/models/dto/refusalPayment.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';

@Component({
  selector: 'app-payment-confirm-reproved',
  templateUrl: './payment-confirm-reproved.component.html',
  styleUrls: ['./payment-confirm-reproved.component.scss'],
})
export class PaymentConfirmReprovedComponent implements OnInit {
  boobleModalData: any;
  buttonSend: boolean;

  reasonRefusalPayment: string = 'Pagamento incompleto';
  valueRefusalPayment: number = null;
  descriptionRefusalPayment: string = '';

  private readonly notifier: NotifierService;
  public loading: boolean;

  constructor(
    private modalService: BoobleModalService,
    notifierService: NotifierService,
    private readonly ordersService: OrdersService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {}

  changeReasonOption() {
    this.valueRefusalPayment = null;
    this.descriptionRefusalPayment = '';
  }

  onDescriptionChange() {
    this.descriptionRefusalPayment =
      this.descriptionRefusalPayment.trim() === ''
        ? ''
        : this.descriptionRefusalPayment;
  }

  validateValueSend() {
    this.buttonSend =
      this.reasonRefusalPayment == 'Pagamento incompleto' &&
      this.valueRefusalPayment == null
        ? true
        : false;

    return this.buttonSend;
  }

  validateDescriptionSend() {
    this.buttonSend =
      this.reasonRefusalPayment == 'Outros' &&
      this.descriptionRefusalPayment == ''
        ? true
        : false;

    return this.buttonSend;
  }

  reprovePayment() {
    this.loading = true;
    const reproveData = new RefusalPaymentDto();

    (reproveData.ReasonRefusalPayment = this.reasonRefusalPayment),
      (reproveData.ValueRefusalPayment = this.valueRefusalPayment),
      (reproveData.DescriptionRefusalPayment =
        this.descriptionRefusalPayment.trim());

    this.ordersService
      .reprovePayment(this?.boobleModalData.id, reproveData)
      .subscribe({
        next: (orderResult) => {
          this.loading = false;
          this.closeModal();
          this.notifier.notify('success', 'Pagamento recusado com sucesso.');
          this.ordersService.updateOrderView();
        },
        error: (err) => {
          this.loading = false;
        },
      });
  }

  closeModal() {
    this.modalService.dismiss(null);
  }
}
